/**
 * Choose the screen-orientation angle (degrees) that matches the deviceorientation frame.
 *
 * `window.orientation` is preferred because iOS reports the gyro in a PORTRAIT-referenced frame,
 * while `screen.orientation.angle` is measured from the device's NATURAL orientation — which is
 * LANDSCAPE on iPad, so it returns 90° in portrait and rolls the scene 90° (objects lie down).
 * `window.orientation` reports 0° in portrait there and is undefined off iOS, where
 * `screen.orientation.angle` is the correct value.
 */
export function resolveScreenOrientationDegrees(input: {
  windowOrientation?: number;
  screenAngle?: number;
}): number {
  if (typeof input.windowOrientation === "number") return input.windowOrientation;
  if (typeof input.screenAngle === "number") return input.screenAngle;
  return 0;
}

/** Current screen orientation in degrees (0 portrait, ±90 landscape). Feeds the gyro pose math. */
export function screenOrientationDegrees(): number {
  return resolveScreenOrientationDegrees({
    windowOrientation: (globalThis as { orientation?: number }).orientation,
    screenAngle: globalThis.screen?.orientation?.angle,
  });
}
